import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { initPixel, trackPageView } from '../../lib/meta-pixel'

export const MetaPixelTracker = () => {
  const location = useLocation()

  useEffect(() => {
    // Inicializar o Pixel na montagem
    initPixel()
  }, [])

  useEffect(() => {
    // Rastrear PageView quando a rota mudar
    trackPageView()
  }, [location.pathname, location.search])

  return null
}
